mutation CreateEvent($eventChanges: EventChangeInput!) {
  createEvent(input: { eventChanges: $eventChanges }) {
    event {
      id
    }
  }
}
